<button mat-icon-button class="close-button" [mat-dialog-close]="true">
    <mat-icon class="close-icon">close</mat-icon>
</button>

<div class="content-wrapper">
    <div class="container-xxl flex-grow-1 container-p-y">
        <div class="row">
            <div class="col-md-12">
                <div mat-dialog-title>
                    <div style="text-align: center;color: red; font-size: 16px;">Are you sure want to create the new payment link ?</div>
                </div>
            </div>
        </div>

        <div class="mat-dialog-content">
            <form (ngSubmit)="onSubmit()">

                <!-- <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Vendor Name</mat-label>
                        <input matInput  [(ngModel)]="data.phone" name="data.phone" required>
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                </div> -->

                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Vendor</mat-label>
                        <input matInput [(ngModel)]="data.VendorId" name="data.VendorId"  readonly="true">
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Service Name</mat-label>
                        <input matInput [(ngModel)]="data.ServiceCode" name="data.ServiceCode"  readonly="true">
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                </div>

                <div class="col-md-12">
                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>Charge Amount</mat-label>
                        <input matInput [(ngModel)]="data.ServiceCharge" name="data.ServiceCharge"  readonly="true">
                        <mat-error>This field is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-12">

                    <mat-form-field appearance="outline" style="width: 100%;">
                        <mat-label>E-mail</mat-label>
                        <input matInput [(ngModel)]="data.PayeeEmail"  name="data.PayeeEmail"  readonly="true">
                        <mat-error>This feild is required</mat-error>
                    </mat-form-field>
                </div>

                <alert></alert>
                <div class="buttonRow">
                    <button mat-raised-button class="button" type="submit"  (click)="onNoClick()"
                        style="margin:0 10px 10px 0;">Yes</button>
                    <button class="buttonReset" type="reset" mat-raised-button [mat-dialog-close]="true">No</button>
                </div>
            </form>
        </div>
    </div>
</div>